"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltipMaxWidth = exports.tooltipMaxHeight = exports.arrowWidth = exports.arrowPosition = void 0;
var arrowWidth = exports.arrowWidth = "14 / 16 * 1.6rem"; // Convert 14px to rem values based on page root font size of 10px to 16px
var tooltipMaxHeight = exports.tooltipMaxHeight = "56 / 16 * 1.6rem"; // Convert 14px to rem values based on page root font size of 10px to 16px
var tooltipMaxWidth = exports.tooltipMaxWidth = "288 / 16 * 1.6rem"; // Convert 288px (responsive grid s breakpoint) to rem values based on page root font size of 10px to 16px
var arrowPosition = exports.arrowPosition = {
  bottomLeft: {
    arrowIndicator: "\n\t\t\ttop: 100%;\n\t\t\tleft: var(--spacing-global-space4);\n\t\t",
    tooltipWrapper: {
      margin: "0 0 var(--spacing-global-space4) 0"
    }
  },
  bottomMiddle: {
    arrowIndicator: "\n\t\t\ttop: 100%;\n\t\t\tleft: calc(50% - (".concat(arrowWidth, " / 2));\n\t\t"),
    tooltipWrapper: {
      margin: "0 0 var(--spacing-global-space4) 0"
    }
  },
  bottomRight: {
    arrowIndicator: "\n\t\t\ttop: 100%;\n\t\t\tright: var(--spacing-global-space4);\n\t\t",
    tooltipWrapper: {
      margin: "0 0 var(--spacing-global-space4) 0"
    }
  },
  left: {
    arrowIndicator: "\n\t\t\tright: 99%;\n\t\t\ttop: calc(50% - (".concat(arrowWidth, " / 2));\n\t\t\ttransform: rotate(90deg);\n\t\t"),
    tooltipWrapper: {
      margin: "0 0 0 var(--spacing-global-space4)"
    }
  },
  right: {
    arrowIndicator: "\n\t\t\tleft: 99%;\n\t\t\ttop: calc(50% - (".concat(arrowWidth, " / 2));\n\t\t\ttransform: rotate(-90deg);\n\t\t"),
    tooltipWrapper: {
      margin: "0 var(--spacing-global-space4) 0 0"
    }
  },
  topLeft: {
    arrowIndicator: "\n\t\t\tbottom: 100%;\n\t\t\tleft: var(--spacing-global-space4);\n\t\t\ttransform: rotate(180deg);\n\t\t",
    tooltipWrapper: {
      margin: "var(--spacing-global-space4) 0 0 0"
    }
  },
  topMiddle: {
    arrowIndicator: "\n\t\t\tbottom: 100%;\n\t\t\tleft: calc(50% - (".concat(arrowWidth, " / 2));\n\t\t\ttransform: rotate(180deg);\n\t\t"),
    tooltipWrapper: {
      margin: "var(--spacing-global-space4) 0 0 0"
    }
  },
  topRight: {
    arrowIndicator: "\n\t\t\tbottom: 100%;\n\t\t\tright: var(--spacing-global-space4);\n\t\t\ttransform: rotate(180deg);\n\t\t",
    tooltipWrapper: {
      margin: "var(--spacing-global-space4) 0 0 0"
    }
  }
};